import { usePagination } from "@vega-api/custom/utils/usePagination";
import { useGetAllDealsV2 } from "@vega-api/generated/deal/deal";
import { usePaginationState } from "@vega-core/hooks/usePaginationState";

import { useCoInvestmentFilters } from "./useCoInvestmentFilters";

export const useCoInvestmentData = () => {
  const { queryParams, RenderFilters } = useCoInvestmentFilters();
  const paginationState = usePaginationState();

  const { data: dealsResponse, isLoading } = useGetAllDealsV2({
    ...queryParams,
    page: paginationState.currentPage,
    pageSize: paginationState.currentPageSize,
  });

  const deals = dealsResponse?.data || [];
  const meta = dealsResponse?.meta;

  const { paginationElement } = usePagination({
    meta,
    isLoading,
    ...paginationState,
    filterDependencies: [
      queryParams.searchQuery,
      queryParams.activeOrPast,
      queryParams.sort?.join(","),
    ],
  });

  return {
    deals,
    isLoading,
    paginationElement,
    RenderFilters,
  };
};
